module.exports = function(input) {
  return input.toString().toLowerCase()
}
